// extracted by mini-css-extract-plugin
export default {"buttonAr":"cKTdx","button":"AhsV2","buttonText":"d13jI","icon":"KgVaY"};